import type { ExclusiveBadgeTheme } from '../ExclusiveBadge';
import type { EventCardVariant } from './EventCard.types';

export const CardholderExclusiveBadgeThemesByVariant = {
  horizontal: 'dark',
  squareOnLight: 'light',
  squareOnDark: 'light',
} as const satisfies Record<EventCardVariant, ExclusiveBadgeTheme>;
